import axios from "axios";

export const gatePassApi = {
  create: async (payload: { studentId: string; reason: string; exitTime: string; expectedReturnTime?: string; approvedBy?: string }) => {
    const res = await axios.post("/scholar-register/gate-pass", payload);
    return res.data;
  },
  list: async (params: { sessionId?: string; classId?: string; sectionId?: string; status?: string; dateFrom?: string; dateTo?: string; studentId?: string }) => {
    const res = await axios.get("/scholar-register/gate-pass", { params });
    return res.data as any[];
  },
  byStudent: async (studentId: string) => {
    const res = await axios.get(`/scholar-register/gate-pass/student/${studentId}`);
    return res.data as any[];
  },
  markReturned: async (id: string, actualReturnTime?: string) => {
    const res = await axios.patch(`/scholar-register/gate-pass/${id}/return`, actualReturnTime ? { actualReturnTime } : {});
    return res.data;
  },
  cancel: async (id: string) => {
    const res = await axios.patch(`/scholar-register/gate-pass/${id}/cancel`);
    return res.data;
  },
};
